
import { Component, Vue } from 'vue-property-decorator'
import { CardClient, CompanyClient } from '@/api'
import CardEditor from './editor.vue'
import CompanyRecharge from './companyRecharge.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'

@Component({
  name: 'CardList',
  components: {
    CardEditor,
    CompanyRecharge
  },
  filters: {
    formatCompany(company : any) {
      return company ? company.name : '未加入任何车队'
    }
  }
})
export default class extends BaseList {
  private rechargeFormVisible=false
  private companyClient = new CompanyClient()
  private companyList = []
  public constructor() {
    super()
    this.client = new CardClient()
    this.listQuery = {
      filter: {
        where: {
          card_number: { like: '' },
          companyId: this.$store.state.user.companyId
        },
        include: [
          { relation: 'company' }
        ],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true
        },
        order: ['createdAt']
      }
    })
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.card_number.like = `%${this.listQuery.filter.where.card_number.like}%`
    if (_.isNil(t.filter.where.companyId) || _.isEqual(t.filter.where.companyId, '')) {
      delete t.filter.where.companyId
    }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: any) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }

  protected async handleRecharge() {
    this.rechargeFormVisible = true
    setTimeout(() => {
      if (this.$refs['companyRecharge']) {
        const companyRecharge = this.$refs['companyRecharge'] as CompanyRecharge
        companyRecharge.reset()
      }
    }, 500)
  }

  protected async recharge() {
    const companyRecharge = this.$refs['companyRecharge'] as CompanyRecharge
    if (await companyRecharge.recharge()) {
      this.rechargeFormVisible = false
      this.getList()
    }
  }
}
